// extracted by mini-css-extract-plugin
export var disabled = "_i-a";
export var hierarchyLinkGray = "_i-4";
export var hierarchyLinkUnderline = "_i-3";
export var hierarchyPrimary = "_i-0";
export var hierarchySecondary = "_i-1";
export var hierarchyTertiary = "_i-2";
export var pressed = "_i-6";
export var themeAction = "_i-5";
export var themeDestructive = "_i-8";
export var themeNormal = "_i-7";
export var themeSuccess = "_i-9";